import { render, staticRenderFns } from "./MenuStudent.vue?vue&type=template&id=46f01680&scoped=true"
import script from "./MenuStudent.vue?vue&type=script&lang=js"
export * from "./MenuStudent.vue?vue&type=script&lang=js"
import style0 from "./MenuStudent.vue?vue&type=style&index=0&id=46f01680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f01680",
  null
  
)

export default component.exports